export default __webpack_public_path__ + "static/media/video-development.588fa151.png";